var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgFunnelLine = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9 22c-.216 0-.427-.07-.6-.2l-4-3.05c-.248-.19-.392-.487-.39-.8v-3.27l-4.8-9.22c-.254-.49-.062-1.094.428-1.348C4.68 4.038 4.839 4 5 4h14c.353 0 .68.186.86.49.179.31.179.69 0 1l-5 9.21V21c.003.38-.21.729-.55.9-.128.062-.268.096-.41.1zm-3-4.54l2 1.53v-4.55c0-.152.034-.303.1-.44l4.3-8H6.64l4.13 8c.073.142.11.3.11.46l.02 3z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFunnelLine, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/funnelLine.ddb9d8db.svg";
export { ForwardRef as ReactComponent };